import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrescriptions = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:#24a81b;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(6.667 3.333)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M9,5H5.667A1.667,1.667,0,0,0,4,6.667v25a1.667,1.667,0,0,0,1.667,1.667H29a1.667,1.667,0,0,0,1.667-1.667v-25A1.667,1.667,0,0,0,29,5H25.667",
					transform: "translate(-4)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M8,16H21.333",
					transform: "translate(-1.333 7.333)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M10,19h6.667",
					transform: "translate(0 9.333)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M10.333,5.333l.745-1.49A3.334,3.334,0,0,1,14.06,2h2.547a3.333,3.333,0,0,1,2.982,1.843l.745,1.49H22A1.667,1.667,0,0,1,23.667,7V8.667A1.667,1.667,0,0,1,22,10.333H8.667A1.667,1.667,0,0,1,7,8.667V7A1.667,1.667,0,0,1,8.667,5.333Z",
					transform: "translate(-2 -2)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M10.5,11.5h5",
					transform: "translate(0.333 4.333)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M12,10v5",
					transform: "translate(1.333 3.333)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H40V40H0Z"
		})
	]
});
export default SvgPrescriptions;
